import Marquee from "react-fast-marquee";
import { Zap } from "lucide-react";
import { MARQUEE_ITEMS } from "@/data/site";

const MarqueeRibbon = () => (
  <div className="border-y border-white/10 bg-[#0C0C0F] py-5" data-testid="marquee-ribbon">
    <Marquee speed={30} gradient={false} pauseOnHover>
      {MARQUEE_ITEMS.map((item) => (
        <span key={item} className="mx-8 flex items-center gap-8">
          <span className="mono text-sm uppercase tracking-[0.25em] text-[#E9C766]">{item}</span>
          <Zap className="h-4 w-4 text-[#D9A92E]" fill="#D9A92E" />
        </span>
      ))}
    </Marquee>
  </div>
);

export default MarqueeRibbon;
